import { useQuery } from "@tanstack/react-query";
import { AdminOrderService } from "../services/adminOrderService";
import {
  DashboardRange,
  ALL_TIME_RANGE,
  rangeKey,
  rangeToParams,
} from "../types/dashboardRange";

// Defaults to all-time so the Orders page tab badges match its unfiltered,
// all-time order list. Date-range filtering stays on the dashboard only.
export const useOrderStats = (range: DashboardRange = ALL_TIME_RANGE) => {
  return useQuery({
    queryKey: ["order-stats", rangeKey(range)],
    queryFn: () => AdminOrderService.getOrderStats(rangeToParams(range)),
  });
};
